import React from 'react';
import styled from 'styled-components';
import { GetColor } from '../../style/color';
import { ELLIPSIS_ITEM } from './utils/Constants';

interface PaginationItemWrapperProps {
  selected: boolean;
}

const PaginationItemWrapper = styled.div<PaginationItemWrapperProps>`
  display: inline-block;
  margin: 0 5px;
  color: ${GetColor.GreyScale.Grey40};

  button,
  button i.fas {
    color: ${(props) => (props.selected ? GetColor.Black : GetColor.DeepDarkBlue)};
    cursor: ${(props) => (props.selected ? 'inherit' : 'pointer')};
  }

  :hover {
    button,
    button i.fas {
      color: ${(props) => (props.selected ? GetColor.Black : GetColor.DeepDarkBlue)};
    }
  }
`;

export interface PaginationItemProps {
  item: number | string;
  selected: boolean;
  onClick?: (item: number | string) => void;
}

export const PaginationItem: React.FC<PaginationItemProps> = ({ item, selected, onClick }) => {
  const handleItemClick = () => {
    onClick?.(item);
  };

  return (
    <PaginationItemWrapper selected={selected}>
      {item === ELLIPSIS_ITEM ? (
        <span>&hellip;</span>
      ) : (
        <button onClick={!selected ? handleItemClick : undefined} type="button">
          {item}
        </button>
      )}
    </PaginationItemWrapper>
  );
};
